<app-header></app-header>
<div class="layout-shell">
  <aside class="layout-shell__sidebar" [class.is-collapsed]="!isMenuOpen()">
    <app-side-bar [isOpen]="isMenuOpen()" [topLinks]="links"></app-side-bar>
  </aside>
  <main class="layout-shell__content">
    <div class="layout-shell__content-inner">
      <div id="main-content" class="layout-shell__route" tabindex="-1">
        <router-outlet></router-outlet>
      </div>
      <app-footer></app-footer>
    </div>
  </main>
</div>

@if (toastOptions$ | async; as toastOptions) {
  <motif-toast
    [type]="toastOptions.type!"
    [show]="true"
    [autoHide]="toastOptions.autoHide!"
    [duration]="toastOptions.duration!"
    [actionText]="toastOptions.actionText! | translate"
    [container]="'body'"
    [placement]="toastOptions.placement!"
    [position]="toastOptions.position!"
    (close)="onToastHidden()"
    (hidden)="onToastHidden()">
    @if (toastOptions.message) {
      <h4>{{ toastOptions.title! | translate }}</h4>
      <p [innerHTML]="toastOptions.message! | translate"></p>
    } @else {
      {{ toastOptions.title! | translate }}
    }
  </motif-toast>
}
